import { getElement } from '../Utility/Dom'

class PortalButton {
  private readonly button: HTMLElement | null
  private readonly closeButton: HTMLElement | null
  private readonly flyout: HTMLElement | null

  constructor() {
    this.button = getElement('portal-button')
    this.closeButton = getElement('portal-close-button')
    this.flyout = getElement('portal-flyout')
  }

  public init(): void {
    if (this.button === null) return
    if (this.closeButton === null) return
    if (this.flyout === null) return

    this.addEvents()
  }

  private addEvents(): void {
    this.button.addEventListener('click', (): void => {
      this.button.setAttribute('aria-expanded', this.isButtonExpanded() ? 'false' : 'true')
    })

    this.closeButton.addEventListener('click', (): void => {
      this.close()
    })

    document.addEventListener('keydown', (event: KeyboardEvent): void => {
      if (event.key === 'Escape' && this.isButtonExpanded()) {
        this.close()
      }
    })

    document.addEventListener('click', (event: MouseEvent): void => {
      const target = event.target as HTMLElement

      if (
        this.isButtonExpanded() &&
        target !== this.button &&
        this.flyout.contains(target) === false
      ) {
        this.close()
      }
    })
  }

  private close(): void {
    this.button.setAttribute('aria-expanded', 'false')
    this.button.focus({ preventScroll: true })
  }

  private isButtonExpanded(): boolean {
    return this.button.getAttribute('aria-expanded') === 'true'
  }
}

const portalButton = new PortalButton()
portalButton.init()
